<template>
  <div style="user-select: none">
    <wg-modal
      v-if="isDropModalOpen"
      :width="windowWidth > 700 ? '500px' : '80%'"
      :portal="true"
      @closeModal="deleteDrop"
    >
      <div slot="header" class="com-anm22-app-text-xl">
        <span>{{
          $anm22.strLang(lang, "Edit project", "Modifica progetto")
        }}</span>
      </div>
      <div slot="body">
        <div>
          {{
            $anm22.strLang(
              lang,
              "Confirm the project new date.",
              "Confermare la nuova data di consegna?",
            )
          }}
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div>
          {{ $anm22.strLang(lang, "Project:", "Progetto:") }}
          {{ dragEvent.name }}
        </div>
        <div>
          {{ $anm22.strLang(lang, "New deadline", "Nuova data:") }}
          {{ dropNewDate.format("Y-MM-DD") }}
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div class="wg-row">
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Confirm', 'Conferma')"
            @click="confirmDrop"
          />
          <input
            type="button"
            :value="$anm22.strLang(lang, 'Delete', 'Annulla')"
            @click="deleteDrop"
            class="com-anm22-button-red"
            style="margin-left: 10px"
          />
        </div>
      </div>
    </wg-modal>
    <div class="anm22-calendar-headmenu" style="padding: 13px 8px 13px 8px">
      <div class>
        <b>
          <span
            :class="[
              'anm22-calendar-change-month-button',
              'prev',
              loadEvent ? 'block' : '',
            ]"
            style="left: 4px"
            @click="prevWeek()"
            >&lt;</span
          >
          <span
            :class="[
              'anm22-calendar-change-month-button',
              'succ',
              loadEvent ? 'block' : '',
            ]"
            style="left: 30px"
            @click="nextWeek()"
            >&gt;</span
          >
          <span class="anm22-calendar-change-week-month">{{
            week.format("MMMM YY").toUpperCase()
          }}</span>
        </b>
      </div>
      <img
        :src="$anm22.icons.getWorldIcon('menuAvailability')"
        @click="$emit('searchEvent')"
        :title="$anm22.strLang(lang, 'Search', 'Cerca')"
        class="filter"
        style="right: 45px; cursor: pointer"
      />

      <span
        style="cursor: pointer; right: 114px"
        @click="newEvent()"
        class="newEventButton"
      >
        <div>
          <span class="wg-xs-none wg-sm- text">{{
            $anm22.strLang(lang, "New Event", "Nuovo Evento")
          }}</span>
          <img :src="$anm22.icons.getWorldIcon('addGreen')" />
        </div>
      </span>
      <!--<img class="filter" :src="$anm22.icons.getWorldIcon('menuAvailability')" style="opacity:0.46;cursor:pointer;">-->
      <img
        @click="changeView()"
        :class="['changeCalendarViewMode', loadEvent ? 'block' : '']"
        :src="$anm22.icons.getWorldIcon('viewFull')"
        :title="$anm22.strLang(lang, 'Change view', 'Cambia visualizzazione')"
        style="opacity: 0.46; cursor: pointer; right: 15px"
      />
      <template v-if="currentW == 'my'">
        <div
          class="my-project-icon work"
          style="cursor: pointer; position: absolute; top: 6px; right: 77px"
          :title="$anm22.strLang(lang, 'My events', 'I miei eventi')"
          @click="$emit('showWorks')"
        >
          {{ user.name.substring(0, 1) }}
        </div>
      </template>
      <template v-else>
        <div class="anm22-calendar-round work">
          <img
            style="
              cursor: pointer;
              position: absolute;
              top: 6px;
              right: 77px;
              width: 32px;
              height: 32px;
              border-radius: 16px;
            "
            :src="
              $anm22.getObjIcon(
                $store.getters['works/get'](currentW),
                'workDefault',
              )
            "
            :title="workCurrent ? workCurrent.name : undefined"
            @click="$emit('showWorks')"
          />
        </div>
      </template>
      <template v-if="box == false">
        <span
          class="anm22-calendar-tutorial-changeWork workBox"
          style="width: 200px; height: 50px; right: 72px"
        >
          {{
            $anm22.strLang(
              lang,
              "To switch the calendar and move to company ones click here.",
              " Per cambiare il calendario e passare a quelli aziendali clicca qui.",
            )
          }}
          <div class="arrowup"></div>
          <div class="close" @click="$emit('close')">X</div>
        </span>
      </template>
      <!-- <div class="myCalendar" title="Mio calendario">M</div>-->
    </div>

    <div class="clear-fix"></div>
    <div class="calendar">
      <div
        class="calendar__sidebar"
        style="
          border-right: 1px solid #e1e1e1;
          border-top: 1px solid #e1e1e1;
          align: center;
        "
      >
        <span v-for="(hour, index) in hours" :key="'hour' + index">
          <div style="height: 37px; border-top: 1px solid #e1e1e1">
            <small style="padding: 5px">{{ hour }}</small>
          </div>
        </span>
      </div>
      <div class="calendar__header">
        <div
          v-for="(element, index) in calendar.slice(0, 7)"
          :key="'grid-head-' + index"
        >
          {{ element.days.format("ddd").toUpperCase() }}
        </div>
      </div>
      <div class="calendar__week">
        <div
          v-for="(element, index) in calendar"
          :key="index"
          class="calendar__day day"
          @click="newEvent(element.days)"
          @dragover.prevent
          @drop.prevent="dropEvent(element.days, $event)"
        >
          <span
            :class="[
              element.days.format('ll').substring(0, 6) === dataCorrente
                ? 'today'
                : '',
            ]"
            :style="{
              color: element.days.format('MMMM') === meseCorrente ? grey : '',
            }"
            >{{ element.days.format("D") }}</span
          >
          <div
            v-if="
              currentW == 16 &&
              dailyCounters.find(
                (obj) => obj.date == element.days.format('DD/MM/YYYY'),
              )
            "
            class="counters"
          >
            <div class="estero">
              {{
                dailyCounters.find(
                  (obj) => obj.date == element.days.format("DD/MM/YYYY"),
                ).ESTERO.value
              }}
            </div>
            <div class="riparazioni">
              {{
                dailyCounters.find(
                  (obj) => obj.date == element.days.format("DD/MM/YYYY"),
                ).RIPARAZIONI.value
              }}
            </div>
            <div class="garanzia">
              {{
                dailyCounters.find(
                  (obj) => obj.date == element.days.format("DD/MM/YYYY"),
                ).GARANZIA.value
              }}
            </div>
            <div class="etichette">
              {{
                dailyCounters.find(
                  (obj) => obj.date == element.day.format("DD/MM/YYYY"),
                ).ETICHETTE.value
              }}
            </div>
          </div>
          <event-bar
            v-for="(event, index) in element.details"
            :key="'event-' + index"
            class="events"
            :styleView="'week'"
            :style="{
              top: eventStyle(event, element.days)[0].top + 'px',
              minHeight: eventStyle(event, element.days)[0].height + 'px',
              height: eventStyle(event, element.days)[0].height + 'px',
            }"
            :eventId="event.idWorldEvent"
            @selectEvent="$emit('selectEvent', $event)"
            :draggable="event.draggable ? true : false"
            @dragstart.native="selectDragEvent(event, $event)"
          ></event-bar>
          <!-- <span v-for="(event,index) in element.details" :key="'event-'+index">
            <div
              @click.stop="$emit('selectEvent', event)"
              class="events"
              :style="{ top : eventStyle(event,element.days)[0].top + 'px',minHeight :eventStyle(event,element.days)[0].height + 'px',height :eventStyle(event,element.days)[0].height + 'px' }"
            >
              {{$moment.unix(event.startTimestamp).format("HH:mm")}}{{$moment.unix(event.endTimestamp).format("HH:mm")}}
              <span v-for="(user,index) in users" :key="'index'+index">
                <span v-if="user.idWorldUser == event.creator">
                  <small>
                    <div class="text-ellipsis">{{event.name}}</div>
                    <img
                      :src="$anm22.getObjIcon(user, 'userDefault')"
                      class="anm22-calendar-icon-inline anm22-calendar-round"
                      style="margin:2px 5px 0 0;"
                      :title="user.name  + user.surname"
                    />
                  </small>
                </span>
              </span>
            </div>
          </span>-->
        </div>
        {{ resetOffset() }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EventBar from "../components/events/EventBar.vue";

export default {
  components: {
    EventBar,
  },
  props: {
    selectedTimezone: [String],
    now: Object,
    events: Array,
    available: Boolean,
    workAvailable: Boolean,
    loadEvent: Boolean,
    box: [Boolean, String],
    currentW: [Number, String],
    currentTime: [Number],
    getMyEvents: [Function],
    getWorkEvents: [Function],
  },
  data() {
    return {
      meseCorrente: this.$moment().format("MMMM"),
      dataCorrente: this.$moment().format("ll").substring(0, 6),
      weekOffset: 0,
      red: "red",
      grey: "grey",
      dataMeet: "",
      name: "Events",
      dragEvent: null,
      dragOffsetY: 0,
      isDropModalOpen: false,
      dropNewDate: null,
      dropNewTimestamp: null,
    };
  },
  computed: {
    ...mapState({
      windowWidth: (state) => state.windowWidth,
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
    }),
    places() {
      return this.$store.getters["contactPlaces/getAll"];
    },
    employments() {
      return this.$store.getters["employments/getAll"];
    },
    work() {
      return this.$store.getters["works/getAll"];
    },
    users() {
      return this.$store.getters["users/getAll"];
    },
    week() {
      //console.log(this.monthOffset);
      return this.now.clone().add(this.weekOffset, "weeks");
    },
    newCurrentData() {
      return this.now.clone().add(this.weekOffset, "weeks");
    },
    newCurrentTime() {
      let a = this.newCurrentData.unix();
      return a;
    },
    workCurrent() {
      return this.$store.getters["works/get"](this.currentW);
    },
    calendar() {
      let result = [];
      const startDay = this.week.clone().startOf("week");
      const endDay = this.week.clone().endOf("week");
      let date = startDay.clone().subtract(1, "day");
      while (date.isBefore(endDay, "day")) {
        let calData = date.add(1, "day").clone();
        let detailsTxt = [];
        let detailsCreator = String;
        this.events.forEach((element) => {
          let title = element.name;
          let idWorldEvent = element.idWorldEvent;
          let startTimestamp = element.startTimestamp;
          let endTimestamp = element.endTimestamp;
          let endEvent = this.$moment.unix(endTimestamp);
          let place = element.place;
          let endH = endEvent.format("H");
          let endM = endEvent.format("MM");
          let startEvents = this.timestampToTimezone(startTimestamp);
          let endEvents = this.timestampToTimezone(endTimestamp);
          // let startEvents = this.$moment.unix(startTimestamp);
          // let endEvents = this.$moment.unix(endTimestamp);
          let endD = endEvent.format("D");
          let day = calData.format("D");
          //il controllo viene fatto sulla fine meno un secondo per il caso particolare che l'evento finisca a mezzanotte
          if (calData.isBetween(startEvents, endEvents - 1, "day", [])) {
            detailsTxt.push(element);
          }
        }),
          result.push({
            days: calData,
            details: detailsTxt.sort(
              (a, b) => a.startTimestamp - b.startTimestamp,
            ),
          });
      }

      return result;
    },
    hours() {
      let result = [];
      let calData = [];
      var dateString = this.$moment().format("L");
      var m = this.$moment(dateString, "L");
      m.set({ HH: 0, mm: 0 });
      for (let m = 0; m <= 24; m++) {
        result.push(m == 0 ? (m = "") : m - 1 + ":00");
      }
      return result;
    },
    dailyCounters() {
      return this.$store.getters["dailyCounters/getAllByWork"](this.currentW);
    },
  },
  methods: {
    newEvent(date) {
      if (!date) {
        this.$emit("newEvent", this.$moment());
      } else {
        this.$emit(
          "newEvent",
          date.clone().set({
            h: this.$moment().format("HH"),
            m: this.$moment().format("mm"),
          }),
        );
      }
    },
    timestampToTimezone(ts) {
      return this.$moment.unix(ts).tz(this.selectedTimezone);
    },
    timestampToDate(ts) {
      const moment = this.timestampToTimezone(ts);
      return this.$moment(
        moment.format("YYYY") +
          "-" +
          moment.format("MM") +
          "-" +
          moment.format("DD"),
      );
    },
    resetOffset() {
      this.lastEventOffsetDay = 0;
      this.lastEventOffsetDayCheck = 0;
      return "";
    },
    eventStyle(event, dayCurrent) {
      let result = [];
      let startEvent = this.$moment.unix(event.startTimestamp);
      let endEvent = this.$moment.unix(event.endTimestamp);
      let day = dayCurrent.format("D");
      let hourHeight = 37;
      let eventTop = 34;
      let minHeight = 28;
      let eventHeight = 0;
      let startH = startEvent.format("H"); //ore inizio
      let startI = startEvent.format("m"); // minuti inizio
      let startD = startEvent.format("D"); //giorno inizio
      let endH = endEvent.format("H"); //ore fine
      let endI = endEvent.format("m"); // minuti fine
      let endMonth = endEvent.format("MM");
      let dayMonth = dayCurrent.format("MM");
      let endD = endEvent.format("D"); //giorno fine
      if (startD == day) {
        eventTop += startH * hourHeight;
        eventTop += parseInt((startI * hourHeight) / 60);
      } else {
        eventTop = hourHeight - 3;
      }
      if (endD == day && endMonth == dayMonth) {
        eventHeight = endH * hourHeight - eventTop;
        eventHeight += parseInt((endI * hourHeight) / 60) + 37;
      } else {
        eventHeight = 24 * hourHeight - eventTop + 37;
      }
      if (eventHeight < minHeight) {
        eventHeight = minHeight;
      }

      let offset = 6;
      if (this.lastEventOffsetDayCheck == day) {
        if (eventTop < this.lastEventOffsetDay + offset) {
          eventTop = this.lastEventOffsetDay + offset;
        }
      }
      this.lastEventOffsetDayCheck = day;
      this.lastEventOffsetDay = eventTop;

      result.push({
        top: eventTop,
        minHeight: minHeight,
        height: eventHeight,
      });
      return result;
    },
    changeView() {
      this.$parent.currentTime = this.$moment().unix();
      this.$parent.loadEvent = true;
      this.currentW === "my" ? this.getMyEvents() : this.getWorkEvents();
      this.$emit("changeView", "LastEventView");
    },
    prevWeek() {
      this.lastEventOffsetDay = 0;
      this.lastEventOffsetDayCheck = 0;
      this.weekOffset--;
      this.$parent.currentTime = this.newCurrentTime;
      this.$parent.loadEvent = true;
      this.currentW === "my" ? this.getMyEvents() : this.getWorkEvents();
    },
    nextWeek() {
      this.lastEventOffsetDay = 0;
      this.lastEventOffsetDayCheck = 0;
      this.weekOffset++;
      this.$parent.currentTime = this.newCurrentTime;
      this.$parent.loadEvent = true;
      this.currentW === "my" ? this.getMyEvents() : this.getWorkEvents();
    },
    selectDragEvent(event, e) {
      this.dragEvent = event;
      const rect = e.currentTarget.getBoundingClientRect();
      this.dragOffsetY = e.clientY - rect.top;
      e.dataTransfer.effectAllowed = "move";
    },
    dropEvent(date, e) {
      // Detect day hour
      const rect = e.currentTarget.getBoundingClientRect();
      const dropY = e.clientY - rect.top - this.dragOffsetY;
      let dropTime = Math.floor((dropY - 37) / 37);
      if (dropTime < 0) {
        dropTime = 0;
      }

      const timestamp = date.unix() + dropTime * 3600;

      this.dropNewDate = date;
      this.dropNewTimestamp = timestamp;
      this.isDropModalOpen = true;
    },
    confirmDrop() {
      /*
      const timestamp = this.dropNewTimestamp;
      const eventLength = this.dragEvent.endTimestamp - this.dragEvent.startTimestamp;
      const endTimestamp = timestamp + eventLength;
      this.dragEvent.startTimestamp = timestamp;
      this.dragEvent.endTimestamp = endTimestamp;
      */

      this.saveProjectDeadline(
        this.dragEvent.projectRef,
        this.dragEvent.work,
        this.dropNewDate,
      );
    },
    deleteDrop() {
      this.dropNewDate = null;
      this.dropNewTimestamp = null;
      this.isDropModalOpen = false;
    },
    saveProjectDeadline(projectId, work, deadline) {
      const deadlineTimestamp = deadline.utc().startOf("day").unix() + 86400;
      this.$http
        .post(
          "/../../../tasks/spa/controller/project/edit/",
          {
            project: {
              idWorldProject: projectId,
              endDate: deadlineTimestamp,
            },
            work,
          },
          {
            withCredentials: true,
          },
        )
        .then((response) => {
          //Salvo con localForage
          this.$store
            .dispatch("projects/update", {
              vlf: this.$vlf("projects"),
              objs: response.data.projects,
            })
            .then(() => {
              // Update event preview
              const timestamp = deadline.utc().startOf("day").unix() + 86400;
              const eventLength = this.dragEvent.endTimestamp - this.dragEvent.startTimestamp;
              const endTimestamp = timestamp + eventLength;
              this.dragEvent.startTimestamp = timestamp;
              this.dragEvent.endTimestamp = endTimestamp;

              // Reset modal
              this.dropNewDate = null;
              this.dropNewTimestamp = null;
              this.isDropModalOpen = false;

              //Per sicurezza aggiorno la copia locale del progetto con quanto salvato nello stato
              this.project = {
                ...this.$store.getters["projects/get"](projectId),
              };
              this.$anm22.eventBus.$emit("world-headbar-show-message", {
                text: this.$anm22.strLang(
                  this.lang,
                  "Project update successful",
                  "Salvataggio progetto avvenuto con successo",
                ),
                type: "suggestion",
              });
            })
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          this.$anm22.eventBus.$emit("world-headbar-show-message", {
            text: this.$anm22.strLang(
              this.lang,
              "Project update error",
              "Errore salvataggio progetto",
            ),
            type: "error",
          });
        });
    },
  },
  created() {
    let lastEventOffsetDay = 0;
    let lastEventOffsetDayCheck = 0;
  },
};
</script>

<style lang="scss" scoped>
.calendar__sidebar {
  position: relative;
  float: left;
  top: 49px;
  text-align: right;
}
.contMenu {
  padding: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1%;
  float: right;
  vertical-align: middle;
}
.today {
  color: white !important;
  background-color: #f00;
  height: 17px;
  width: 17px;
  border-radius: 50%;
  display: inline-block;
  padding-right: 4px;
  padding-top: 1px;
  padding-left: 2px;
}
.block {
  pointer-events: none;
}
@media screen and (max-width: 779px) {
  .anm22-calendar-change-week-month {
    margin-left: 50px;
  }
}
.anm22-calendar-change-month-button {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 24px;
  height: 24px;
  margin: 0;
  border-radius: 15px;
  text-align: center;
  cursor: pointer;
  display: inline-block;
  position: absolute;
  top: 11px;
  line-height: 1;
  padding: 2px 0 0 0;
}
.workBox {
  position: absolute;
  top: 108px;
  right: 20px;
  padding: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 40px;
  height: 40px;
  border-radius: 3px;
  background-color: white;
  -webkit-box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  color: black;
  line-height: 1;
  font-size: 14px;
  text-align: left;
  font-weight: 400;
}
.close {
  color: #aaa;
  float: right;
  font-size: 14px;
  margin-top: -27px;
  margin-right: -5px;
  font-weight: bold;
  cursor: pointer;
}
.arrowup {
  width: 0px;
  height: 0px;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #fff;
  position: absolute;
  right: 8px;
  top: -10px;
}
.week-text {
  font-size: 2.9em;
  color: #a8b2b9;
}

.toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}
.anm22-calendar-headmenu-custom {
  padding: 13px 8px 13px 0px;
  position: relative;
  height: 46px;
  box-sizing: border-box;
  background-color: #fafafa;
  line-height: 1;
  font-size: 18px;
}
.my-project-icon {
  display: inline-block;
  background-color: #00af87;
  color: #fff;
  padding-top: 7px;
  line-height: 1.1;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
  border-radius: 30px;
  vertical-align: middle;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.work {
  width: 32px;
  height: 32px;
  border-radius: 16px;
}
.toggle {
  display: grid;
  grid-template-columns: 1fr 1fr;

  text-align: center;
  font-size: 0.9em;
}
.toggle__option {
  padding: 16px;
  border: 1px solid #e1e1e1;
  border-radius: 8px;
  text-transform: capitalize;
  cursor: pointer;
}
.toggle__option:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.toggle__option:last-child {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.toggle__option--selected {
  border-color: white;
  background-color: white;
  color: var(--red);
  font-weight: 500;
  box-shadow: 1px 2px 30px -5px var(--red);
}

.monthBar {
  width: 100%;
  text-align: center;
  display: flex;
  margin-top: 10px;
  display: inline-block;
}

.day-of-week {
  width: calc(100% / 7);
  justify-content: center;
}

.wg-row {
  //background-color: #eee;
  height: 50px;
  text-align: center;
}

.centered {
  position: relative;
  align-content: center;
  margin-top: 15px;
}
@media screen and (max-height: 300px) {
  .anm22-calendar-headmenu {
    height: 46px;
  }
  .anm22-calendar-headmenu .newEventButton {
    top: 13px;
  }

  .anm22-calendar-headmenu .filter {
    top: 8px;
  }
  .anm22-calendar-headmenu .changeCalendarViewMode {
    top: 11px;
  }
}

.day-block {
  height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0 2px;
  cursor: pointer;
  &.other-month {
    opacity: 0.4;
  }
  &:hover {
    background-color: #eee;
  }
}
.day-projects-div {
  height: 100%;
  & div {
    height: calc(100% / 6);
    padding: 1px 2px;
  }
}
.project-label {
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 2px;
  background-color: #fff;
}

.current_momth {
  font-family: Montserrat;
  font-weight: 100;
  color: #a8b2b9;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.calendar__week,
.calendar__header {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.calendar__week {
  grid-auto-rows: 100px;
}

.calendar__header {
  grid-auto-rows: 50px;
  align-items: center;
  text-align: center;
}

.calendar__day {
  box-sizing: border-box;
  padding: 10px;
}
// @media (max-width: 767px) {
//   .calendar__day {
//   padding: 0px;
//   max-width: 65px;
//   min-width:30px;
// }
// }
@media (max-width: 290px) {
  .newEventButton {
    display: none;
  }
}
@media (max-width: 1200px) {
  .calendar__day {
    // padding: 0px;
    //padding-top: 17px;
    min-width: 0px;
  }
  .events {
    max-width: 96%;
  }
}
.calendar {
  background-color: #ffffff;
  // border: 1px solid #e1e1e1;
  height: 652px;
}

.calendar__header > div {
  text-transform: uppercase;
  font-size: 0.8em;
  font-weight: bold;
}

.calendar__day {
  border-right: 1px solid #e1e1e1;
  border-top: 1px solid #e1e1e1;
  border-left: 1px solid #e1e1e1;
  height: 960px;
  position: relative;
}

.events {
  padding: 1px;
  margin: 2px;
  width: 98%;
  background-color: #eeeeee;
  border-radius: 6px;
  cursor: pointer;
  position: absolute;
  box-sizing: border-box;
  left: 0%;
  overflow: hidden;
  border: 2px solid #ffffff;

  &.outlined {
    border-width: 1px;
  }
}
.text-ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.events:hover {
  color: #000000;
  z-index: 100;
  height: auto !important;
}
.reminder:hover {
  background-color: #888;
  color: white;
  border-color: #666;
}

.counters {
  position: absolute;
  top: 9px;
  right: 8px;

  div {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    text-align: left;
    margin-right: 2px;

    &.estero {
      color: #ff0000;
    }
    &.riparazioni {
      color: #ffca28;
    }
    &.garanzia {
      color: #f400a1;
    }
    &.etichette {
      color: #ff6f00;
    }
  }
}

@media screen and (max-width: 650px) {
  .counters {
    right: 0;
  }
}
@media screen and (max-width: 550px) {
  .counters {
    top: -19px;
    width: 100%;
    text-align: center;
  }
}
</style>
